import React from 'react';
import { useSelector } from 'react-redux';
import { selectIsAdvancedMode } from 'store/Filters/selectors';
import FilterError from './components/FilterError';
import { SearchBarWrapper, Wrapper } from './styled';
import BasicFilter from './components/BasicFilter';
import AdvancedFilter from './components/AdvancedFilter';
import AdvancedModeSelector from './components/AdvancedModeSelector';
import SaveFilter from './components/SaveFilter';
import { selectPathname } from 'store/Router/selectors';

const FilterBar = () => {
  const isAdvancedMode = useSelector(selectIsAdvancedMode);
  return isAdvancedMode ? <AdvancedFilter /> : <BasicFilter />;
};

const SearchBar = () => {
  const pathname = useSelector((state) => selectPathname(state));
  const searchBarStyle = pathname.includes('/hosts') ||
  pathname.includes('/vulnerabilities') ||
  pathname.includes('/workspaces') ||
  pathname.startsWith('/services') ||
  pathname.includes('/workspaces') ||
  (pathname.startsWith('/host/') && !pathname.endsWith('/services') && !pathname.endsWith('/vulns')) ||
  pathname.startsWith('/manage/') ||
  pathname.startsWith('/service/') ||
  pathname.includes('/report') ||
  pathname.includes('automation/schedule') ||
  pathname.includes('/credentials');

  const showSaveFilter =
  !pathname.includes('/workspaces') &&
  !pathname.includes('/services') &&
  !pathname.includes('/service') &&
  !pathname.includes('/knowledge_base');

  return (
    <Wrapper searchBarStyle={ searchBarStyle }>
      <SearchBarWrapper>
        <FilterBar />
        <FilterError />
        <AdvancedModeSelector />
      </SearchBarWrapper>
      {showSaveFilter && <SaveFilter />}
    </Wrapper>
  );
};

export default SearchBar;
